import { Modal, Button, Form, Row, Col, Select, InputNumber } from "antd";
import { ALL_SERVICE, BOOKING_APPLY_SERVICE } from "../../../constants/api";
import { displayMessage, getAPI, postAPI } from "../../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../../constants/messages";
import { useEffect, useState } from "react";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

export default function ExtraServiceModal({ visible, onClose, booking_id }) {
  const [loading, setLoading] = useState(true);
  const [services, setServices] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    getList();
  }, []);

  const getList = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status) {
        setServices(data.data);
      }
      setLoading(false);
    };

    const errorFn = function () {
      setServices([]);
      setLoading(false);
    };

    getAPI(ALL_SERVICE, successFn, errorFn, {});
  };

  const onFinish = (values) => {
    values["bookingId"] = booking_id;
    console.log("onFinish: ", values);
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        onClose();
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to apply service");
    };
    postAPI(BOOKING_APPLY_SERVICE, values, successFn, errorFn);
  };

  return (
    <Modal
      loading={loading}
      title="Add Extra Services"
      open={visible}
      onCancel={onClose}
      width={900}
      footer={
        <>
          <Button
            htmlType="submit"
            type="primary"
            onClick={() => form.submit()}
          >
            Save Booking
          </Button>
        </>
      }
    >
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Form.List name="extra_services">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Row gutter={16} key={key} align="middle" className="mb-2">
                  <Form.Item
                    {...restField}
                    name={[name, "gst_amount"]}
                    label="GST AMT"
                    hidden={true}
                  />
                  <Col span={8}>
                    <Form.Item
                      {...restField}
                      name={[name, "extra_service_id"]}
                      label="Select Service"
                      rules={[{ required: true, message: "Required" }]}
                    >
                      <Select
                        placeholder="Select"
                        onChange={(value) => {
                          const selected = services.find((s) => s.id === value);
                          if (selected) {
                            const list = form.getFieldValue("extra_services");
                            const gst =
                              (parseFloat(selected.price) *
                                (parseInt(selected?.gst_percent) || 0)) /
                              100;
                            const qty = 1;
                            const newList = [...list];
                            newList[name] = {
                              ...newList[name],

                              price: parseInt(selected.price),
                              gst_percent: parseInt(selected.gst_percent),
                              gst_amount: (
                                (selected.price * selected.gst_percent) /
                                100
                              ).toFixed(2),
                              total_gst_amount: (gst * qty).toFixed(2),
                            };
                            form.setFieldsValue({ extra_services: newList });
                          }
                        }}
                      >
                        {services.map((s) => (
                          <Select.Option key={s.id} value={s.id}>
                            {s.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={3}>
                    <Form.Item
                      {...restField}
                      name={[name, "price"]}
                      label="Price"
                      rules={[{ required: true }]}
                    >
                      <InputNumber
                        placeholder="Price"
                        style={{ width: "100%" }}
                        onChange={(value) => {
                          const list = form.getFieldValue("extra_services");
                          const row = list[name];
                          const gst = (value * (row?.gst_percent || 0)) / 100;
                          const qty = row?.quantity || 1;
                          const newList = [...list];
                          newList[name] = {
                            ...row,
                            price: value,
                            gst_amount: gst.toFixed(2),
                            total_gst_amount: (gst * qty).toFixed(2),
                          };
                          form.setFieldsValue({ extra_services: newList });
                        }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={3}>
                    <Form.Item
                      {...restField}
                      name={[name, "gst_percent"]}
                      label="GST%"
                      rules={[{ required: true }]}
                    >
                      <InputNumber
                        placeholder="GST %"
                        style={{ width: "100%" }}
                        onChange={(value) => {
                          const list = form.getFieldValue("extra_services");
                          const row = list[name];
                          const gst = ((row?.price || 0) * value) / 100;
                          const qty = row?.quantity || 1;
                          const newList = [...list];
                          newList[name] = {
                            ...row,
                            gst_percent: value,
                            gst_amount: gst.toFixed(2),
                            total_gst_amount: (gst * qty).toFixed(2),
                          };
                          form.setFieldsValue({ extra_services: newList });
                        }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={2}>
                    <Form.Item
                      {...restField}
                      name={[name, "quantity"]}
                      label="QTY"
                      initialValue={1}
                      rules={[{ required: true }]}
                    >
                      <InputNumber
                        placeholder="Qty"
                        min={1}
                        style={{ width: "100%" }}
                        onChange={(value) => {
                          const list = form.getFieldValue("extra_services");
                          const row = list[name];
                          const totalGst = (row?.gst_amount || 0) * value;
                          const newList = [...list];
                          newList[name] = {
                            ...row,
                            quantity: value,
                            total_gst_amount: totalGst.toFixed(2),
                          };
                          form.setFieldsValue({ extra_services: newList });
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      {...restField}
                      name={[name, "total_gst_amount"]}
                      label="GST Amount"
                    >
                      <InputNumber
                        placeholder="GST Amount"
                        style={{ width: "100%" }}
                        disabled
                      />
                    </Form.Item>
                  </Col>

                  <Col span={2}>
                    <MinusCircleOutlined onClick={() => remove(name)} />
                  </Col>
                </Row>
              ))}

              <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<PlusOutlined />}
                >
                  Add Extra Service
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      </Form>
    </Modal>
  );
}
